import React from 'react'
import { injectIntl } from 'gatsby-plugin-intl'

const QuoteHighlight = ( { domain, intl } ) => (
  <div className="highlight quote hidden">
    <q>{ intl.formatMessage( { id: `highlights.${ domain }.quote` } ) }</q>
    <small>{ intl.formatMessage( { id: `highlights.${ domain }.author` } ) }</small>
  </div>
)

const injected = injectIntl( QuoteHighlight )
export { injected as QuoteHighlight }
